import { object, string, array } from 'zod';

import { makeZodValidate } from '@occc/ui-forms';
import { IS_REQUIRED, IS_VALID } from '@occc-app/lib/constants/validationMessages';
import { validatePhoneNumber } from '@occc/utils-phone-number';

import {
  brandingDetailsValidation,
  scheduleValidation,
} from '../retailer-network-location-update-page/retailer-network-location-update-page.validation';

const generalDetailsSchema = object({
  details: object({
    name: string({ required_error: IS_REQUIRED }),
    locationGroup: object({ uuid: string() }).optional().nullable(),
    street1: string({ required_error: IS_REQUIRED }),
    street2: string().optional(),
    city: string({ required_error: IS_REQUIRED }),
    state: object(
      {
        id: string(),
        text: string(),
      },
      { required_error: IS_REQUIRED, invalid_type_error: IS_REQUIRED },
    ),
    zipCode: string({ required_error: IS_REQUIRED }).regex(
      /^[0-9]{5}$/,
      'Zip code must be 5 digits',
    ),
    phoneNumber: string()
      .optional()
      .refine((val) => !val || validatePhoneNumber(val), {
        message: IS_VALID,
      }),
    availableServices: array(string()).optional(),
    brandingDetails: brandingDetailsValidation,
  }),
  schedule: scheduleValidation.partial(),
});

export const validateGeneralDetailsForm = makeZodValidate(generalDetailsSchema);
